import { matchPath } from 'react-router';
var findSelectedMenu = function (AppBuilderMenuItems, pathname) {
    var selectedMenuMain = AppBuilderMenuItems.find(function (item) {
        return matchPath(pathname, item.activationPathMatch);
    });
    var selectedMenuSub = AppBuilderMenuItems.find(function (item) {
        var _a;
        return (_a = item.children) === null || _a === void 0 ? void 0 : _a.find(function (child) {
            var _a;
            return (_a = child.data) === null || _a === void 0 ? void 0 : _a.find(function (childData) {
                return matchPath(pathname, childData.activationPathMatch);
            });
        });
    });
    var selectedMenu = selectedMenuMain || selectedMenuSub;
    return selectedMenu;
};
export default findSelectedMenu;
